<fgb-mobile-page-header [pageTitle]="'wallet.page.title'" backButtonLink="/" [showQr]="false" [showBalance]="false" />
<div class="container mobile-container">
  <div class="py-3">
    <div class="text-white cursor-pointer d-none d-lg-flex btn-circle-gloss bg-glass" (click)="goBack()">
      <span class="material-icons pe-1">arrow_back_ios_new</span>
    </div>
  </div>

  <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
</div>
